import React, { useState } from "react";
import PropTypes from "prop-types";
import Avatar from "./Avatar";
import ChatMenu from "./ChatMenu";

const ChatWidget = ({ isVisible = true, onCloseAvatar }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen((prev) => !prev);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <ChatMenu isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <Avatar onClick={toggleChat} onClose={onCloseAvatar} />
    </>
  );
};

ChatWidget.propTypes = {
  isVisible: PropTypes.bool,
  onCloseAvatar: PropTypes.func,
  ChatUserId: PropTypes.any,
  isChat: PropTypes.any,
  ChatBusinessId: PropTypes.any,
};

export default ChatWidget;
